import { render, staticRenderFns } from "./BasicContainer.vue?vue&type=template&id=f0510904&scoped=true"
import script from "./BasicContainer.vue?vue&type=script&lang=js"
export * from "./BasicContainer.vue?vue&type=script&lang=js"
import style0 from "./BasicContainer.vue?vue&type=style&index=0&id=f0510904&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0510904",
  null
  
)

export default component.exports